<mat-dialog-content class="tip-dialog-scrollable">
  <mat-toolbar color="primary" class="tip-dialog-toolbar">
    <span>{{ isEdit ? 'Edit Tip' : 'Add New Tip' }}</span>
    <span class="spacer"></span>
    <button mat-icon-button mat-dialog-close aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
  <form [formGroup]="tipForm" class="tip-form um-form">
    <mat-form-field appearance="fill" floatLabel="always" class="w-100 mb-1 form-feild">
      <mat-label>Source</mat-label>
      <input matInput formControlName="source" />
      <mat-error *ngIf="tipForm.get('source')?.hasError('required')">
        Source is required
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" floatLabel="always" class="w-100 mb-1 form-feild">
      <mat-label>Version</mat-label>
      <input matInput formControlName="version" />
      <mat-error *ngIf="tipForm.get('version')?.hasError('required')">
        Version is required
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" floatLabel="always" class="w-100 mb-1 form-feild">
      <mat-label>Heading</mat-label>
      <input matInput formControlName="heading" />
      <mat-error *ngIf="tipForm.get('heading')?.hasError('required')">
        Heading is required
      </mat-error>
    </mat-form-field>
    <div *ngIf="!isEdit" class="w-100 mb-1">
      <label for="fileInput">Select Image:</label> &nbsp;&nbsp;
      <input id="fileInput" type="file" (change)="onFileSelected($event)" />
      <mat-error *ngIf="!selectedFile">
        Image is required
      </mat-error>
    </div>
    <div class="w-100 mb-1 mb-5" *ngIf="isEdit && imageUrl">
      <label for="fileInput">Image:</label><br />
      <div *ngIf="isEdit && imageUrl" class="mb-1">
        <img [src]="imageUrl" alt="Existing Image" width="150" style="margin: 5px 0;" />
      </div>
      <input id="fileInput" type="file" (change)="onFileSelected($event)" />
      <mat-error *ngIf="!selectedFile && !imageUrl && !isEdit">
        Image is required
      </mat-error>
    </div>

    <mat-form-field appearance="fill" floatLabel="always" class="w-100 mb-1 form-feild">
      <mat-label>Short Description</mat-label>
      <textarea matInput rows="2" formControlName="short_desc"></textarea>
      <mat-error *ngIf="tipForm.get('short_desc')?.hasError('required')">
        Short description is required
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" floatLabel="always" class="w-100 mb-0 form-feild">
      <mat-label>Long Description</mat-label>
      <textarea matInput rows="3" formControlName="long_desc"></textarea>
      <mat-error *ngIf="tipForm.get('long_desc')?.hasError('required')">
        Long description is required
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-card-actions align="end" class="tip-dialog-actions">
  <button mat-stroked-button (click)="onCancel()" class="cancel-btn">Cancel</button>
  <!-- <button
      *ngIf="isEdit"
      mat-stroked-button
      color="warn"
      (click)="onDelete()"
    >
      Delete
    </button> -->
  <button mat-raised-button color="primary" (click)="onSubmit()" class="update-btn" [disabled]="
        tipForm.invalid ||
        (!isEdit && !selectedFile)
      ">
    {{ isEdit ? 'Update' : 'Submit' }}
  </button>
</mat-card-actions>